import React from "react";

const ICON = {
    width: "16",
    height: "16",
    colors: {
        candidate: "#00466e",
        company: "#94D63D"
    }
};

const IconCurrency = ({ iconType, currency }) => {
    return(   
        <svg width={ICON.width} height={ICON.height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.1875 2.94336C9.26953 2.94336 8.51758 3.2168 7.93164 3.76367C7.35221 4.31055 6.96484 5.13737 6.76953 6.24414L11.2227 6.24414L11.2227 7.74805L6.62305 7.74805L6.60352 8.1875L6.60352 8.72461L6.62305 9.10547L10.6074 9.10547L10.6074 10.5996L6.78906 10.5996C7.20573 12.6309 8.39063 13.6465 10.3438 13.6465C11.2747 13.6465 12.2285 13.4447 13.2051 13.041L13.2051 15.0234C12.3522 15.4206 11.3594 15.6191 10.2266 15.6191C8.65755 15.6191 7.38151 15.1895 6.39844 14.3301C5.42188 13.4707 4.78385 12.2272 4.48438 10.5996L3 10.5996L3 9.10547L4.32813 9.10547L4.30859 8.74414L4.30859 8.38281L4.32813 7.74805L3 7.74805L3 6.24414L4.46484 6.24414C4.71224 4.61003 5.33398 3.32747 6.33008 2.39648C7.32617 1.46549 8.61198 1 10.1875 1C11.4896 1 12.6549 1.28646 13.6836 1.85937L12.8633 3.68555C11.8607 3.19076 10.9688 2.94336 10.1875 2.94336Z" fill={iconType === "candidate" ? ICON.colors.candiate : ICON.colors.company} />
        </svg>
    )
}

export default IconCurrency;